export default "Gå i jægerstenalderfolkets fodspor og sank spiselige planter, bær og nødder fra naturens spisekammer.\n";